import { authApiAuthenticationConfig, createAuthTokenJWTMiddleware } from '@paysera/authentication';
import { createAuthApiAuthenticationClient } from '@paysera/auth-api-authentication-client';
import createAxiosClient from '@app/clients/api/axios';
import TokenService from '@app/clients/api/TokenService';
const authClient = createAuthApiAuthenticationClient({
    baseURL: authApiAuthenticationConfig.baseURL,
    middleware: [createAuthTokenJWTMiddleware()],
});
const tokenService = new TokenService(authClient, 'loans-api-token');
const loansApiClient = createAxiosClient(process.env.LOANS_API_BASE_URL, tokenService, 'loans_api', 'confirmed_log_in');
export default loansApiClient;
